import React from 'react';
import { Box, Button, Checkbox, FormControl, FormControlLabel, FormHelperText, Grid, InputLabel, MenuItem, Select, TextField, Tooltip, Typography } from "@mui/material";
import { useState } from 'react';
import { grey } from '@mui/material/colors';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { AddLeaveTypeAction, UpdateLeaveTypeAction } from '../../../../../store/Leave/LeaveType/Action';
import SelectableSearch from '../../../Base/views/SelectableSearch';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const LeaveTypesPopup = ({ editedRecord, setOpenPopup }) => {
    const dispatch = useDispatch();
    const isEditable = editedRecord
    const [leaveTypes, setLeaveTypes] = useState({
        name: "",
        code: "",
        actual_days: "",
        req_second_approval: false,
        cfwd_leave: false,
        gender_based: false,
        is_unlimited: false,
        noof_cfwd_days: "",
        gender: "",
        colour_code: "#de4fcd",
        leave_type: "flat",
        credit_type: "",
        credit_time: "",
        yearly_credit: "",
        monthly_credit: "",
        is_attendance_considered: false,
    });

    const [errors, setErrors] = useState({});
    const [genderOptions, setGenderOptions] = useState({ load: true, values: [] })

    useEffect(() => {
        if (editedRecord != null) {
            setLeaveTypes({ ...editedRecord, gender: { id: 0, name: editedRecord?.gender } });
        }
    }, [editedRecord])

    const validate = (fieldValues) => {
        let temp = { ...errors };

        if ("name" in fieldValues) {
            temp.name = fieldValues.name === "" ? "Name is required" : "";
        }
        if ("code" in fieldValues) {
            temp.code = fieldValues.code === "" ? "Code is required" : "";
        }
         if ("leave_type" in fieldValues) {
            temp.leave_type = (fieldValues.leave_type === "" || fieldValues.leave_type === null) ? "Leave Type is required" : "";
        }
        if (fieldValues?.leave_type === "flat") {
            if ("actual_days" in fieldValues) {
                temp.actual_days = fieldValues.actual_days === "" ? "Yearly Allotted Days is required" :
                    fieldValues?.actual_days?.toString().match(/^\d{1,3}(\.\d{1,2})?$/)
                        ? ""
                        : "Invalid Yearly Allotted Days.";
            }
            temp.credit_type = "";
            temp.credit_time = "";
            temp.yearly_credit = "";
            temp.monthly_credit = "";
        }
         if (fieldValues.leave_type === "variable") {
            if ("credit_type" in fieldValues) {
                temp.credit_type = fieldValues.credit_type === "" ? "Credit Frequency is required" : "";
            }
            if ("credit_time" in fieldValues) {
                temp.credit_time = fieldValues.credit_time === "" ? "Credit Timing is required" : "";
            }
            if (fieldValues.credit_type === "yearly_accrual" && "yearly_credit" in fieldValues) {
                temp.yearly_credit = fieldValues.yearly_credit === "" ? "Credit Leave Days is required" :
                    fieldValues?.yearly_credit?.toString().match(/^\d{1,3}(\.\d{1,2})?$/)
                        ? ""
                        : "Invalid Credit Leave Days.";
                temp.monthly_credit = "";
            }
            if (fieldValues.credit_type === "monthly_accrual" && "monthly_credit" in fieldValues) {
                temp.monthly_credit = fieldValues.monthly_credit === "" ? " Credit Leave Days is required" :
                    fieldValues?.monthly_credit?.toString().match(/^\d{1,3}(\.\d{1,2})?$/)
                        ? ""
                        : "Invalid Credit Leave Days.";
                temp.yearly_credit = "";
            }
            // Clear flat field errors
            temp.actual_days = "";
        }
        if (fieldValues?.leave_type === "flat") {
            if ("credit_time" in fieldValues) {
                temp.credit_time = fieldValues.credit_time === "" ? "Credit Timing is required" : "";
            }
        }
        if ("req_second_approval" in fieldValues) {
            temp.req_second_approval = fieldValues.req_second_approval === "" ? "Request Second Approval is required" : "";
        }
        if (leaveTypes?.cfwd_leave && "noof_cfwd_days" in fieldValues) {
            temp.noof_cfwd_days = fieldValues.noof_cfwd_days === "" ? "Days is required" :
                fieldValues?.noof_cfwd_days?.toString().match(/^[0-9]{1,3}$/)
                    ? ""
                    : "Invalid Percentage.";
        }

        setErrors({
            ...temp,
        });

        return Object.values(temp).every((x) => x === "");
    };
    const handleInputChange = (event, value) => {
        if (["gender"].includes(event)) {
            if (value) {
                setLeaveTypes({ ...leaveTypes, [event]: value });
            } else {
                setLeaveTypes({ ...leaveTypes, [event]: "" });
            }
        } else if (["req_second_approval", "is_unlimited"].includes(event.target.name)) {
            setLeaveTypes({ ...leaveTypes, [event.target.name]: event.target.checked });
        } else if (event.target.name === "gender_based") {
            if (event.target.checked === false) setLeaveTypes({ ...leaveTypes, [event.target.name]: event.target.checked, gender: "" });
            else setLeaveTypes({ ...leaveTypes, [event.target.name]: event.target.checked });
        } else if (["cfwd_leave", "is_attendance_considered"].includes(event.target.name)) {
            if (event.target.checked) setLeaveTypes({ ...leaveTypes, [event.target.name]: event.target.checked });
            else {
                setLeaveTypes({
                    ...leaveTypes,
                    [event.target.name]: event.target.checked,
                    ...(event.target.name === "cfwd_leave" && { noof_cfwd_days: "" })
                });
                setErrors({ ...errors, ...(event.target.name === "cfwd_leave" && { noof_cfwd_days: "" }) })
            }
        } else if (["leave_type"].includes(event.target.name)) {
            if (event.target.value === "flat") {
                setLeaveTypes({
                    ...leaveTypes,
                    [event.target.name]: event.target.value,
                    credit_type: "",
                    credit_time: "",
                    yearly_credit: "",
                    monthly_credit: ""
                });
                setErrors({ ...errors, credit_type: "", credit_time: "", yearly_credit: "", monthly_credit: "" })
            } else {
                setLeaveTypes({
                    ...leaveTypes,
                    [event.target.name]: event.target.value,
                    actual_days: "",
                    credit_time: "",
                });
                setErrors({ ...errors, actual_days: "" })
            }
            Object.values?.(errors)?.find(res => res !== "")?.length > 0 &&
                validate({ ...leaveTypes, [event.target.name]: event.target.value })
        } else if (["credit_type"].includes(event.target.name)) {
            if (event.target.value === "yearly_accrual") {
                setLeaveTypes({
                    ...leaveTypes,
                    [event.target.name]: event.target.value,
                    monthly_credit: ""
                });
                setErrors({ ...errors, monthly_credit: "", yearly_credit: "", credit_type: "" })
            } else {
                setLeaveTypes({
                    ...leaveTypes,
                    [event.target.name]: event.target.value,
                    yearly_credit: ""
                });
                setErrors({ ...errors, yearly_credit: "", monthly_credit: "", credit_type: "" })
            }
        } else {
            setLeaveTypes({ ...leaveTypes, [event.target.name]: event.target.value });
            Object.values?.(errors)?.find(res => res !== "")?.length > 0 &&
                validate({ ...leaveTypes, [event.target.name]: event.target.value })
        }
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        if (validate(leaveTypes)) {
            if (leaveTypes?.leavetype_id) dispatch(UpdateLeaveTypeAction(leaveTypes));
            else dispatch(AddLeaveTypeAction(leaveTypes));
            setOpenPopup(false);
        }

    }

    const genderLoading = () => {
        setGenderOptions({ load: false, values: [{ id: 1, name: "Male" }, { id: 2, name: "Female" }] })
    }

    return (
        <>
            <Grid container>
                <Grid container>
                    <Grid key="name" item xs={12} md={6} sx={{ marginTop: "1rem", paddingRight: "15px", paddingLeft: "15px" }}>
                        <FormControl fullWidth >
                            <TextField
                                size="small"
                                value={leaveTypes?.name}
                                onChange={handleInputChange}
                                variant="outlined"
                                fullWidth
                                required
                                disabled={isEditable}
                                autoFocus={true}
                                id="name"
                                label="Name"
                                name="name"
                                {...(errors.name && {
                                    error: true,
                                    helperText: errors.name,
                                })}
                            />
                        </FormControl>
                    </Grid>
                    <Grid key="code" item xs={12} md={6} sx={{ marginTop: "1rem", paddingRight: "15px", paddingLeft: "15px" }}>
                        <FormControl fullWidth >
                            <TextField
                                size="small"
                                value={leaveTypes?.code}
                                onChange={handleInputChange}
                                variant="outlined"
                                fullWidth
                                disabled={isEditable}
                                required
                                id="code"
                                label="Code"
                                name="code"
                                {...(errors.code && {
                                    error: true,
                                    helperText: errors.code,
                                })}
                            />
                        </FormControl>
                    </Grid>
                    <Grid key="colour_code" item xs={12} md={6} sx={{ marginTop: "1rem", paddingRight: "15px", paddingLeft: "15px" }}>
                        <FormControl fullWidth>
                            <TextField
                                type={"color"}
                                size="small"
                                value={leaveTypes?.colour_code}
                                onChange={handleInputChange}
                                variant="outlined"
                                fullWidth
                                disabled={isEditable}
                                id="colour_code"
                                label="Colour Code"
                                name="colour_code"
                            />
                        </FormControl>
                    </Grid>

                    <Grid key="leave_type" item xs={12} md={6} sx={{ marginTop: "1rem", paddingRight: "15px", paddingLeft: "15px" }}>
                        <FormControl fullWidth error={!!errors?.leave_type} size="small">
                            <InputLabel id="leave-credit-type-label">Credit Type *</InputLabel>
                            <Select
                                labelId="leave-credit-type-label"
                                name="leave_type"
                                disabled={isEditable}
                                value={leaveTypes?.leave_type}
                                label="Credit Type"
                                onChange={handleInputChange}
                            >
                                <MenuItem value="flat">Flat</MenuItem>
                                <MenuItem value="variable">Variable</MenuItem>
                            </Select>
                            <FormHelperText>{errors?.leave_type}</FormHelperText>
                        </FormControl>
                    </Grid>
                    {leaveTypes?.leave_type === "flat" && (
                        <>
                            <Grid key="credit_time" item xs={12} md={6} sx={{ marginTop: "1rem", paddingRight: "15px", paddingLeft: "15px" }}>
                                <FormControl fullWidth error={!!errors?.credit_time} size="small">
                                    <InputLabel id="credit-time-label">Credit Timing *</InputLabel>
                                    <Select
                                        labelId="credit-time-label"
                                        name="credit_time"
                                        disabled={isEditable}
                                        value={leaveTypes?.credit_time}
                                        label="Credit Timing"
                                        onChange={handleInputChange}
                                    >
                                        <MenuItem value="start">Start of Period</MenuItem>
                                        <MenuItem value="end">End of Period</MenuItem>
                                    </Select>
                                    <FormHelperText>{errors?.credit_time}</FormHelperText>
                                </FormControl>
                            </Grid>
                            <Grid key="actual_days" item xs={12} md={6} sx={{ marginTop: "1rem", paddingRight: "15px", paddingLeft: "15px" }}>
                                <FormControl fullWidth>
                                    <TextField
                                        size="small"
                                        value={leaveTypes?.actual_days}
                                        onChange={handleInputChange}
                                        variant="outlined"
                                        fullWidth
                                        disabled={isEditable}
                                        required
                                        type='number'
                                        id="actual_days"
                                        label="Yearly Allotted Days"
                                        name="actual_days"
                                        placeholder='000.00'
                                        sx={{
                                            "& input::placeholder": {
                                                color: "#B0B0B0",
                                            },
                                        }}
                                        {...(errors.actual_days && {
                                            error: true,
                                            helperText: errors.actual_days,
                                        })}
                                    />
                                </FormControl>
                            </Grid>
                        </>
                    )}
                    {leaveTypes?.leave_type === "variable" && (
                        <>
                            <Grid key="credit_type" item xs={12} md={6} sx={{ marginTop: "1rem", paddingRight: "15px", paddingLeft: "15px" }}>
                                <FormControl fullWidth error={!!errors?.credit_type} size="small">
                                    <InputLabel id="credit-type-label">Credit Frequency *</InputLabel>
                                    <Select
                                        labelId="credit-type-label"
                                        name="credit_type"
                                        disabled={isEditable}
                                        value={leaveTypes?.credit_type}
                                        label="Credit Frequency"
                                        onChange={handleInputChange}
                                    >
                                        <MenuItem value="monthly_accrual">Monthly Accrual</MenuItem>
                                        <MenuItem value="yearly_accrual">Yearly Accrual</MenuItem>
                                    </Select>
                                    <FormHelperText>{errors?.credit_type}</FormHelperText>
                                </FormControl>
                            </Grid>
                            <Grid key="credit_time" item xs={12} md={6} sx={{ marginTop: "1rem", paddingRight: "15px", paddingLeft: "15px" }}>
                                <FormControl fullWidth error={!!errors?.credit_time} size="small">
                                    <InputLabel id="credit-time-label">Credit Timing *</InputLabel>
                                    <Select
                                        labelId="credit-time-label"
                                        name="credit_time"
                                        disabled={isEditable}
                                        value={leaveTypes?.credit_time}
                                        label="Credit Timing"
                                        onChange={handleInputChange}
                                    >
                                        <MenuItem value="start">Start of Period</MenuItem>
                                        <MenuItem value="end">End of Period</MenuItem>
                                    </Select>
                                    <FormHelperText>{errors?.credit_time}</FormHelperText>
                                </FormControl>
                            </Grid>
                            <Grid key="yearly_credit" item xs={12} md={12} sx={{ marginTop: "1rem", paddingRight: "15px", paddingLeft: "15px" }}>
                                <FormControl fullWidth sx={{ width: '47%' }} >
                                    <TextField
                                        size="small"
                                        value={leaveTypes?.credit_type === "yearly_accrual"
                                            ? leaveTypes?.yearly_credit
                                            : leaveTypes?.credit_type === "monthly_accrual"
                                                ? leaveTypes?.monthly_credit
                                                : ""}
                                        onChange={handleInputChange}
                                        disabled={isEditable}
                                        variant="outlined"
                                        fullWidth
                                        type='number'
                                        required
                                        id="yearly_credit"
                                        label="Credit Leave Days"
                                        name={leaveTypes?.credit_type === "yearly_accrual"
                                            ? "yearly_credit"
                                            : "monthly_credit"}
                                        placeholder='000.00'
                                        sx={{
                                            "& input::placeholder": {
                                                color: "#B0B0B0",
                                            },
                                        }}
                                        {...((leaveTypes?.credit_type === "yearly_accrual"
                                            ? errors?.yearly_credit
                                            : errors?.monthly_credit) && {
                                            error: true,
                                            helperText: (leaveTypes?.credit_type === "yearly_accrual"
                                                ? errors?.yearly_credit
                                                : errors?.monthly_credit),
                                        })}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid key="is_attendance_considered" item xs={12} md={6} sx={{ marginTop: "0.75rem", paddingRight: "0px", paddingLeft: "15px" }}>
                                <FormControl
                                    component="fieldset"
                                    variant="standard"
                                >
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                name="is_attendance_considered"
                                                checked={leaveTypes?.is_attendance_considered}
                                                onChange={handleInputChange}
                                                disabled={isEditable}
                                            />}
                                        label={
                                            <Box display="flex" alignItems="center">
                                                Credit Based on Attendance?
                                                <Tooltip title="Leave will be credited only if attendance requirements are fulfilled.">
                                                    <InfoOutlinedIcon sx={{ fontSize: 16, ml: 0.5, color: "#888" }} />
                                                </Tooltip>
                                            </Box>
                                        }
                                    />
                                </FormControl>
                            </Grid>
                        </>
                    )}
                    <Grid key="cfwd_leave" item xs={12} md={6} sx={{ marginTop: "0.75rem", paddingRight: "15px", paddingLeft: "15px" }}>
                        <FormControl
                            component="fieldset"
                            variant="standard"
                        >
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="cfwd_leave"
                                        checked={leaveTypes?.cfwd_leave}
                                        onChange={handleInputChange}
                                        disabled={isEditable}
                                    />}
                                label="Yearly Carry Forward Leave?"
                            />
                        </FormControl>
                    </Grid>
                    {
                        leaveTypes?.cfwd_leave &&
                        <Grid key="noof_cfwd_days" item xs={12} md={6} sx={{ marginTop: "0.75rem", paddingRight: "15px", paddingLeft: "15px" }}>
                            <FormControl fullWidth>
                                <TextField
                                    size="small"
                                    value={leaveTypes?.noof_cfwd_days}
                                    onChange={handleInputChange}
                                    variant="outlined"
                                    fullWidth
                                    type="number"
                                    disabled={isEditable}
                                    id="noof_cfwd_days"
                                    label="Yearly Carry Forward Days"
                                    placeholder='EX: 60'
                                    name="noof_cfwd_days"
                                    {...(errors.noof_cfwd_days && {
                                        error: true,
                                        helperText: errors.noof_cfwd_days,
                                    })}
                                />
                            </FormControl>
                        </Grid>
                    }
                    <Grid key="gender_based" item xs={12} md={6} sx={{ marginTop: "0.75rem", paddingRight: "15px", paddingLeft: "15px" }}>
                        <FormControl
                            component="fieldset"
                            variant="standard"
                        >
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="gender_based"
                                        disabled={isEditable}
                                        checked={leaveTypes?.gender_based}
                                        onChange={handleInputChange}
                                    />}
                                label="Gender based leave?"
                            />
                        </FormControl>
                    </Grid>

                    {
                        leaveTypes?.gender_based &&
                        <Grid key="gender" item xs={12} md={6} sx={{ marginTop: "0.75rem", paddingRight: "15px", paddingLeft: "15px" }}>
                            <FormControl fullWidth>
                                <SelectableSearch
                                    label="Gender"
                                    value={leaveTypes?.gender}
                                    loading={genderLoading}
                                    fieldLabel="name"
                                    autoFocus={false}
                                    disabled={isEditable}
                                    required={false}
                                    variant={"outlined"}
                                    name="gender"
                                    size="small"
                                    onChangeEvent={handleInputChange}
                                    data={genderOptions}
                                    {...(errors.gender && {
                                        error: true,
                                        helperText: errors.gender,
                                    })}
                                />
                            </FormControl>
                        </Grid>
                    }
                    {/*  <Grid key="req_second_approval" item xs={12} md={6} sx={{ marginTop: "1rem", paddingRight: "15px", paddingLeft: "15px" }}>

                            <FormGroup>
                                <FormControlLabel
                                    control={<Switch
                                        checked={leaveTypes?.req_second_approval}
                                        name="req_second_approval"
                                        onChange={handleInputChange}
                                    />}
                                    label="Request Second Approval"
                                />
                            </FormGroup>
                        </Grid>
                         <Grid key="is_unlimited" item xs={12} md={6} sx={{ marginTop: "1rem", paddingRight: "15px", paddingLeft: "15px" }}>

                            <FormGroup>
                                <FormControlLabel
                                    control={<Switch
                                        checked={leaveTypes?.is_unlimited}
                                        name="is_unlimited"
                                        onChange={handleInputChange}
                                    />}
                                    label="Unlimited Leaves?"
                                />
                            </FormGroup>
                        </Grid> */}
                </Grid>
                <Box sx={{ width: "100%", textAlign: "left", border: "1px solid #ccc", borderRadius: 2, p: 2, backgroundColor: "#f9f9f9", m: 2 }}>
                    <Typography
                        variant="subtitle1"
                        sx={{
                            fontWeight: 500,
                            color: "#333",
                        }}
                    >
                        {isEditable ? "⚠️ Contact Meepl Admin team for custom changes." :
                            "⚠️ Once this leave type is configured, it cannot be deleted or switched to another Credit Type."}
                    </Typography>
                    {leaveTypes?.leave_type === "flat" && (
                        <Typography variant="subtitle2" sx={{ color: "#555", fontWeight: 500, }}>
                        ℹ️ Flat Credit: Leave is credited once per year based on the selected timing and leave year type. If an employee joins mid-year, leave is credited on a prorated basis.
                        </Typography>
                    )}

                    {leaveTypes?.leave_type === "variable" && (
                        <Typography variant="subtitle2" sx={{ color: "#555", fontWeight: 500, }}>
                        ℹ️ Variable Credit: Leave is credited automatically based on the selected frequency, timing and leave year type. Attendance rules may apply if enabled.
                        </Typography>
                    )}
                </Box>
                {!editedRecord &&
                    <Grid container sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                    }}>
                        <Button
                            sx={{ marginTop: "1rem", marginRight: "1rem", ":hover": { color: grey[50] } }}
                            variant="outlined"
                            onClick={() => setOpenPopup(false)}
                            className="mpl-secondary-btn"
                        >
                            cancel
                        </Button>
                        <Button variant="contained" color="primary" onClick={handleSubmit} className="mpl-primary-btn" sx={{ marginTop: "1rem", marginRight: "1rem" }}>
                            {editedRecord ? "Update" : "Save"}
                        </Button>
                    </Grid>}
            </Grid>
        </>
    );
}

export default LeaveTypesPopup;
